import React from "react";
import { useUniversities } from "@/services/useUniversities";

const UniversityList: React.FC = () => {
    const { data, isLoading, isError } = useUniversities();

    if (isLoading) return <p>Loading...</p>;
    if (isError) return <p>Gagal memuat daftar universitas.</p>;

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {data?.map((u) => (
                <div key={u.name} className="flex flex-col items-center">
                    <img
                        src={u.image}
                        alt={u.name}
                        className="w-16 h-16 object-contain mb-2"
                    />
                    <span className="text-sm font-medium text-center">{u.name}</span>
                </div>
            ))}
        </div>
    );
};

export default UniversityList;
